import React from "react";
// import "./PinnedPaymentCard.css";

const BookingPinnedCard = ({ pinned }) => {
  if (!pinned) return null;

  return (
    <div className="wa-pinned-wrapper">
      <div className="wa-pinned-content">
        <span className="pin-icon">📌</span>

        <div className="wa-pinned-text">
          <div className="wa-title">
            {pinned?.service_id?.serviceName || pinned?.eventType ||pinned?.serviceCategory} | ₹{pinned?.totalAmount}
          </div>

          <div className="wa-subtitle">
            {pinned?.city}, {pinned?.state}
          </div>

          <div className="wa-subtitle">
            Status: {pinned?.paymentStatus} 
            {pinned?.paymentMode && pinned?.paymentMode !== "NA" && ` | Mode: ${pinned?.paymentMode}`}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BookingPinnedCard;